import { render, staticRenderFns } from "./LogisticMainKanban.vue?vue&type=template&id=53c20e99&"
import script from "./LogisticMainKanban.vue?vue&type=script&lang=js&"
export * from "./LogisticMainKanban.vue?vue&type=script&lang=js&"
import style0 from "./LogisticMainKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports